import { lazy } from "react";
import RenderSubSection from "./RenderSubSections";

const OrderDaily = lazy(() => import("pages/orders/OrderDaily"));
const DryOrderDaily = lazy(() => import("pages/orders/DryOrderDaily"));
const OfflineOrderDaily = lazy(() => import("pages/orders/OfflineOrderDaily"));
const OrdersStatusDaily = lazy(() => import("pages/orders/OrdersStatusDaily"));
const OrdersOfflineStatusDaily = lazy(
    () => import("pages/orders/OfflineOrderStatus")
);
const OfflineOrdersStatusDetail = lazy(
    () => import("pages/orders/OfflineOrderStatusDetail")
);
const DryOrdersStatus = lazy(() => import("pages/orders/DryOrderStatus"));
const ConvertOrders = lazy(() => import("pages/orders/OrdersConvertor"));

const OrderStatusDetailDaily = lazy(
    () => import("pages/orders/OrderStatusDetailDaily")
);
const DryOrderStatusDetail = lazy(
    () => import("pages/orders/DryOrderStatusDetail")
);
const VendorsInvoice = lazy(() => import("pages/orders/VendorsInvoice"));
const CreateVendorInvoice = lazy(
    () => import("pages/orders/CreateVendorInvoice")
);

const dailyOrder = {
    name: "ثبت سفارش روزانه",
    path: "/new-orders-daily",
    group: "new-orders-daily",
    exact: true,
    component: () => <OrderDaily />,
};

const orderList = {
    name: "وضعیت سفارش‌های روزانه",
    path: "/orders-status-daily",
    group: "orders-status-daily",
    exact: true,
    component: () => <OrdersStatusDaily />,
};

const orderStatus = {
    name: "وضعیت سفارش‌های روزانه",
    path: "/orders-status-detail-daily/:id",
    group: "orders-status-detail-daily",
    isHide: true,
    component: () => <OrderStatusDetailDaily />,
};

const orderStatusView = {
    name: "مشاهده وضعیت سفارش‌های روزانه",
    path: "/view-status-detail-daily/:id",
    group: "view-status-detail-daily",
    isHide: true,
    component: () => <OrderStatusDetailDaily />,
};

const orderDry = {
    name: "ثبت سفارش بار خشک",
    path: "/dry-orders-daily",
    group: "dry-orders-daily",
    exact: true,
    component: () => <DryOrderDaily />,
};

const orderDryList = {
    name: "وضعیت سفارش‌های بار خشک",
    path: "/dry-orders-detail",
    group: "dry-orders-detail",
    exact: true,
    component: () => <DryOrdersStatus />,
};

const orderDryStatus = {
    name: "وضعیت سفارش‌های بار خشک",
    path: "/dry-orders-detail/:id",
    group: "dry-orders-detail",
    isHide: true,
    component: () => <DryOrderStatusDetail />,
};

const orderOffline = {
    name: "ثبت سفارش آفلاین",
    path: "/offline-orders-daily",
    group: "offline-orders-daily",
    exact: true,
    component: () => <OfflineOrderDaily />,
};

const orderOfflineList = {
    name: "وضعیت سفارش‌های آفلاین",
    path: "/offline-orders-detail",
    group: "offline-orders-detail",
    exact: true,
    component: () => <OrdersOfflineStatusDaily />,
};

const orderOfflineStatus = {
    name: "وضعیت سفارش‌های آفلاین",
    path: "/offline-orders-detail/:id",
    group: "offline-orders-detail",
    isHide: true,
    component: () => <OfflineOrdersStatusDetail />,
};

const ordersConvertor = {
    name: "تبدیل‌گر سفارشات",
    path: "/orders-convertor",
    group: "orders-convertor",
    exact: true,
    component: () => <ConvertOrders />,
};

const invoiceList = {
    name: "فاکتور ارسالی وندورها",
    path: "/vendors-invoice",
    group: "vendors-invoice",
    exact: true,
    component: () => <VendorsInvoice />,
};

const newInvoice = {
    name: "اضافه کردن فاکتور ارسالی جدید",
    path: "/new-vendor-invoice",
    group: "new-vendor-invoice",
    isHide: true,
    component: () => <CreateVendorInvoice />,
};

const subSections = {
    main: {
        list: { ...orderList },
        create: { ...dailyOrder },
        update: { ...orderStatus },
        view: { ...orderStatusView },
    },
    dry: {
        list: { ...orderDryList },
        create: { ...orderDry },
        update: { ...orderDryStatus },
        view: { ...orderDryStatus },
    },
    offline: {
        list: { ...orderOfflineList },
        create: { ...orderOffline },
        update: { ...orderOfflineStatus },
        view: { ...orderOfflineStatus },
    },
    convert: {
        list: { ...ordersConvertor },
    },
    invoice: {
        list: { ...invoiceList },
        create: { ...newInvoice },
    },
};

const orderSection = {
    title: "سفارشات",
    key: "order",
    SubRoutes: (keywords: any) => RenderSubSection(keywords, subSections),
};

export default orderSection;
